

import { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { getButtonsConfig } from "../config/buttonsConfig";

import GenericModal from "./GenericModal";

export default function SuccessModal({ additionalDetails = {} }) {
  const BUTTONS = getButtonsConfig(additionalDetails);
  return (
    <GenericModal
      iconName={SvgEnum.HisCheckCircle2}
      iconColor={HNSColors.success[500]}
      iconBgColor={HNSColors.success[700]}
      title="Success!"
      titleColor={HNSColors.success[500]}
      message="The information has been saved successfully."
      buttons={[BUTTONS.OK]}
    />
  );
}
